module.exports = __webpack_public_path__ + "507005aa91db97aa379165c11e2e2ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/loop-button-icon.png
// module id = 44
// module chunks = 0